// extracted by mini-css-extract-plugin
export var breadcrumb = "Breadcrumb-module--breadcrumb--42r0P";
export var breadcrumbItem = "Breadcrumb-module--breadcrumb-item--vmDbI";
export var active = "Breadcrumb-module--active--A1Lnf";
export var breadcrumbLink = "Breadcrumb-module--breadcrumb-link--3i+4-";
export var focusVisible = "Breadcrumb-module--focus-visible--XKMvm";